"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dsa = void 0;
const common_1 = require("./common");
const screens_1 = require("./screens");
exports.dsa = {
    common: common_1.common,
    screens: screens_1.screens,
};
